import { useCallback, useEffect, useMemo, useRef } from 'react';
import {
  defaultOnFormHandle,
  DefaultOnFormHandleProps,
  defaultOnGridHandle,
  DefaultOnGridHandleProps,
} from '../heplers';
import { useSearchParams } from '../../hooks';

export type UseFormGrid = ReturnType<typeof useFormGrid>;

export const useFormGrid = (query: string) => {
  const { replace, query: routeQuery } = useSearchParams();
  const queryValue = routeQuery[query];
  const queryValuePreview = routeQuery[`${query}_preview`];
  const editItemID = useMemo<string | boolean>(() => {
    return queryValue === 'true' ? true : queryValue || false;
  }, [queryValue]);
  const previewItemID = useMemo<string | boolean>(() => {
    return queryValuePreview || false;
  }, [queryValuePreview]);
  const setEditItemID = useCallback(
    (v: boolean | string | null) => {
      replace({ [query]: v ? String(v) : null });
    },
    [query, replace],
  );
  const setPreviewID = useCallback(
    (v: boolean | string | null) => {
      replace({ [`${query}_preview`]: v ? String(v) : null });
    },
    [query, replace],
  );
  const grid = useRef<any>(null);

  // handlers
  const onGridHandle = useCallback<(value: DefaultOnGridHandleProps['value']) => void>(
    (value) => defaultOnGridHandle({ value, setEditItemID, setPreviewID }),
    [setEditItemID, setPreviewID],
  );
  const onFormHandle = useCallback<(value: DefaultOnFormHandleProps['value']) => void>(
    (value) => defaultOnFormHandle({ value, setEditItemID, grid }),
    [grid, setEditItemID],
  );
  // edit
  useEffect(() => {
    if (query) replace({ [query]: editItemID ? String(editItemID) : null });
  }, [query, editItemID, replace]);
  // preview
  useEffect(() => {
    const query_ = `${query}_preview`;
    if (query_) replace({ [query_]: previewItemID ? String(previewItemID) : null });
  }, [query, previewItemID, replace]);

  return {
    grid,
    onGridHandle,
    onFormHandle,
    editItemID,
    setEditItemID,
    previewItemID,
    setPreviewID,
  };
};
